import VueRouter from "vue-router";
import qs from "qs";
import routes from './routes';

export default new VueRouter({
    routes,
    base: '/agenda',
    mode: 'history',
    parseQuery: query => qs.parse(query, { strictNullHandling: true }),
    stringifyQuery: query => qs.stringify(query, { addQueryPrefix: true, skipNulls: true }),
});